module.exports = __webpack_public_path__ + "img/60044.008c721a.png";